{
	"title": "Impressum",
	"backTitle": "Zurück",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Straße 6",
			"city": "69120 Heidelberg",
			"country": "Deutschland"
		},
		"contact": {
			"telephone": "Telefon: +49 6221 481-0",
			"telefax": "Telefax: +49 6221 481-13553",
			"email": "E-Mail: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Sitz der Gesellschaft: Heidelberg",
			"commercialRegister": "Registergericht: Mannheim, HRB 741878",
			"managingDirectors": "Geschäftsführer:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
